import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ReactDOM from 'react-dom'
import './SelectLeague.css'

const SearchForPlayer = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedAllPlayers, setLoadedAllPlayers] = useState([])
	const [searchTerm, setSearchTerm] = useState('')
	const [filteredResults, setFilteredResults] = useState([])
	const [error, setError] = useState()

	const navigate = useNavigate()

	// refs for positioning portal dropdown
	const inputRef = useRef(null)
	const dropdownRef = useRef(null)
	const [dropdownPos, setDropdownPos] = useState(null)

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/getAllPlayers',
				)
				const responseData = await response.json()
				if (!response.ok) throw new Error(responseData.message)
				setLoadedAllPlayers(responseData.allPlayers || [])
			} catch (err) {
				setError(err.message)
			} finally {
				setIsLoading(false)
			}
		}
		sendRequest()
	}, [])

	const playerArray = useMemo(() => {
		if (!loadedAllPlayers?.length) return []
		const sorted = [...loadedAllPlayers].sort(
			(a, b) =>
				a.lastName.localeCompare(b.lastName) ||
				a.firstName.localeCompare(b.firstName),
		)
		return sorted.map((p) => `${p.lastName}, ${p.firstName} | ${p.usabh}`)
	}, [loadedAllPlayers])

	useEffect(() => {
		if (!searchTerm || searchTerm.length <= 3) {
			setFilteredResults([])
			return
		}
		const term = searchTerm.toLowerCase()
		const results = playerArray.filter((p) => p.toLowerCase().includes(term))
		setFilteredResults(results.slice(0, 60))
	}, [searchTerm, playerArray])

	const closeDropdown = () => setFilteredResults([])

	const computeDropdownPos = () => {
		const el = inputRef.current
		if (!el) return
		const r = el.getBoundingClientRect()
		setDropdownPos({
			left: r.left + window.scrollX,
			top: r.bottom + window.scrollY + 4,
			width: r.width,
		})
	}

	// Whenever results show, position the dropdown
	useEffect(() => {
		if (filteredResults.length > 0) computeDropdownPos()
	}, [filteredResults.length])

	// Keep dropdown aligned on scroll/resize
	useEffect(() => {
		const onScroll = () => {
			if (filteredResults.length > 0) computeDropdownPos()
		}
		const onResize = () => {
			if (filteredResults.length > 0) computeDropdownPos()
		}

		window.addEventListener('scroll', onScroll, true)
		window.addEventListener('resize', onResize)
		return () => {
			window.removeEventListener('scroll', onScroll, true)
			window.removeEventListener('resize', onResize)
		}
	}, [filteredResults.length])

	const handleItemClick = (item) => {
		const [lastName, rest] = item.split(', ')
		const [firstName, usabh] = rest.split(' | ')

		const found = loadedAllPlayers.find(
			(p) =>
				p.usabh === usabh &&
				p.lastName === lastName &&
				p.firstName === firstName,
		)

		if (found?._id) {
			navigate(`/${found._id}/history`)
			setSearchTerm('')
			closeDropdown()
		}
	}

	useEffect(() => {
		const onClick = (e) => {
			const inputEl = inputRef.current
			const ddEl = dropdownRef.current

			// If click is inside input OR inside dropdown, do nothing
			if (inputEl && inputEl.contains(e.target)) return
			if (ddEl && ddEl.contains(e.target)) return

			// Otherwise close
			closeDropdown()
		}

		document.addEventListener('click', onClick)
		return () => document.removeEventListener('click', onClick)
	}, [])

	return (
		<React.Fragment>
			<div style={{ marginBottom: '2rem', overflowX: 'hidden' }}>
				{!isLoading && (
					<div className='row'>
						<div className='col'></div>

						<div className='col-sm'>
							<input
								ref={inputRef}
								className='searchInput'
								type='text'
								placeholder='Enter player name to search'
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								onFocus={() => {
									if (filteredResults.length > 0) computeDropdownPos()
								}}
							/>

							{searchTerm.length > 3 && filteredResults.length === 0 && (
								<p style={{ textAlign: 'center' }}>No results found.</p>
							)}
						</div>

						<div className='col'></div>
					</div>
				)}
			</div>

			{/* PORTAL DROPDOWN (renders above everything, never clipped) */}
			{filteredResults.length > 0 &&
				dropdownPos &&
				ReactDOM.createPortal(
					<ul
						ref={dropdownRef}
						className='playerSearchDropdownPortal'
						style={{
							position: 'absolute',
							left: dropdownPos.left,
							top: dropdownPos.top,
							width: dropdownPos.width,
							zIndex: 999999,
						}}
					>
						{filteredResults.map((item) => (
							<li
								key={item}
								className='playerSearchResult'
								onMouseDown={(e) => {
									e.preventDefault() // prevents input blur weirdness
									handleItemClick(item)
								}}
							>
								{item}
							</li>
						))}
					</ul>,
					document.body,
				)}
		</React.Fragment>
	)
}

export default SearchForPlayer

/* //This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'

const SearchForPlayer = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedAllPlayers, setLoadedAllPlayers] = useState()
	const [searchTerm, setSearchTerm] = useState('')
	const [filteredResults, setFilteredResults] = useState([])
	const [error, setError] = useState()

	let selectedPlayer

	console.log('inside SearchForPlayer')
	//
	//
	//
	//
	//
	//Call backend to get all players in the system for our dropdown
	//************************************************************************************************
	//
	//    DROPDOWN OF ALL PLAYERS
	//
	//When this page renders, we want to go get all the players
	//Then turn the list of players into an Array of lastName, space, firstName, space, middle initial
	//
	//
	//*************************************************************************************************
	useEffect(() => {
		//console.log('inside useEffect')
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/getAllPlayers',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedAllPlayers(responseData.allPlayers)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])

	let playerArray

	//Once we have all loaded players, let's sort them by lastName/firstName
	if (loadedAllPlayers && !isLoading) {
		loadedAllPlayers.sort(function (a, b) {
			return (
				a.lastName.localeCompare(b.lastName) ||
				a.firstName.localeCompare(b.firstName)
			)
		})
		//Here's where we make our array that we'll map through later for our dropdown list
		playerArray = []
		loadedAllPlayers.forEach((player) => {
			const lastFirstMiddle =
				player.lastName + ', ' + player.firstName + ' | ' + player.usabh
			playerArray.push(lastFirstMiddle)
		})
	}
	//
	//
	//

	let navigate = useNavigate()

	//
	//
	//
	//
	//
	useEffect(() => {
		if (searchTerm === '') {
			setFilteredResults([]) // Clear results if search term is empty
			return
		}
		const results = playerArray.filter((player) =>
			player.toLowerCase().includes(searchTerm.toLowerCase()),
		)
		setFilteredResults(results)
	}, [searchTerm]) // Re-run effect when searchTerm or allItems changes

	//
	//
	const handleItemClick = (item) => {
		console.log('item: ' + item)
		const split = item.split(', ')
		const lastName = split[0]
		const firstNameAndUsabh = split[1]
		console.log('lastName: ' + lastName)
		const split2 = firstNameAndUsabh.split(' | ')
		const firstName = split2[0]
		const usabh = split2[1]
		console.log('firstName: ' + firstName)
		console.log('usabh: ' + usabh)

		let playerId

		for (const player of loadedAllPlayers) {
			if (
				player.usabh === usabh &&
				player.lastName === lastName &&
				player.firstName === firstName
			) {
				//console.log('player found: ' + JSON.stringify(player))
				playerId = player._id
				navigate(`/${playerId}/history`)
				setSearchTerm('')
			}
		}
	}
	//
	//
	//
	const handleInputChange = (event) => {
		setSearchTerm(event.target.value)
	}

	return (
		<React.Fragment>
			<div style={{ marginBottom: '2rem', overflowX: 'hidden' }}>
				{!isLoading && loadedAllPlayers && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<input
								className='searchInput'
								type='text'
								placeholder='Enter player name to search'
								value={searchTerm}
								onChange={handleInputChange}
							/>
							{searchTerm.length > 3 && filteredResults.length > 0 && (
								<ul className='playerSearchDropdown'>
									{filteredResults.map((item) => (
										<li
											// onClick={handleChange1}
											className='searchInput'
											onClick={() => handleItemClick(item)}
											style={{ textAlign: 'center', listStyleType: 'none' }}
											key={item}
										>
											{item}
										</li>
									))}
								</ul>
							)}
							{searchTerm && filteredResults.length === 0 && (
								<p>No results found.</p>
							)}
						</div>
						<div className='col'></div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default SearchForPlayer
 */
